import { Button, DatePicker, Divider, message } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "styled-components";
import { FacebookOutlined, ShareAltOutlined } from "@ant-design/icons";

import { Text } from "../../helpers/StyledComponents";
import { TabletSize } from "../../constant";
import NoData from "../../components/NoData/NoData";
import Loading from "../../components/Common/Loading";
import dailyBread from "./dailyBread.json";

const dateFormat = "DD-MM-YYYY";
const URL = "https://su-thailand.org/";
const DAILY_BREAD_URL = process.env.REACT_APP_DAILY_BREAD_URL;

const DailyBreadContainer = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const currentDate = dayjs();
  const formattedDate = currentDate.format(dateFormat);
  const [date, setDate] = useState("");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const pathReplaced = `dailyBread?date=${date.replaceAll("/", "-")}`;
  const customFormat = (value) =>
    `เลือกวันที่เพื่ออ่านพลังประจำวัน: ${value.format(dateFormat)}`;

  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        `${URL}/${pathReplaced}`
      )}`,
      "_blank"
    );
  };

  const shareToLine = () => {
    window.open(
      `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        `${URL}/${pathReplaced}`
      )}`,
      "_blank"
    );
  };

  const handleDateChange = (date) => {
    setDate(dayjs(date).format(dateFormat));
  };

  const copyButton = () => {
    navigator.clipboard.writeText(`${URL}daily-bread?date=${date}`);
    messageApi.open({
      type: "success",
      content: "Link has been copied to clipboard",
      duration: 5,
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const dateParam = searchParams.get("date");

    if (dateParam) {
      setDate(dateParam);
    } else {
      setDate(formattedDate);
    }
  }, [formattedDate, location.search]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        // const res = await fetch(DAILY_BREAD_URL);
        // const json = await res.json();
        const entry = dailyBread.find((item) => item.date === date);

        if (entry) {
          const parser = new DOMParser();
          const parsedHTML = parser.parseFromString(entry.detail, "text/html");
          const links = parsedHTML.querySelectorAll("a");
          links.forEach((link) => {
            link.setAttribute("target", "_blank");
          });
          const modifiedHTML = parsedHTML.documentElement.innerHTML;
          setData({ ...entry, detail: modifiedHTML });
        } else {
          setData(null);
        }
      } catch (err) {
        console.error("Error fetching JSON:", err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date]);

  return (
    <>
      {contextHolder}
      <Loading isLoading={loading}>
        <div style={{ minHeight: "100dvh" }}>
          <Container>
            <Text fontSize="45" fontSizeMb="25" color="white">
              อ่านพลังประจำวัน
            </Text>
            <Text fontSize="35" fontSizeMb="20" color="white">
              {data?.title}
            </Text>
            <Divider style={{ width: "200px" }} />
            <CustomDatePicker
              value={dayjs(date, dateFormat)}
              format={customFormat}
              onChange={handleDateChange}
              allowClear={false}
              placement="bottomRight"
            />
          </Container>
          <ContentContainer>
            {data ? (
              <>
                <ContentText
                  dangerouslySetInnerHTML={{ __html: data?.detail }}
                />
                <Divider />
                <ButtonSection>
                  <Button type="primary" onClick={() => copyButton()}>
                    <div>Copy Link</div>
                  </Button>
                  <Button type="primary" onClick={shareToFacebook}>
                    <ButtonText>
                      <FacebookOutlined />
                      แชร์ไปยัง Facebook
                    </ButtonText>
                  </Button>
                  <Button
                    type="primary"
                    onClick={shareToLine}
                    style={{ background: "#06C755" }}
                  >
                    <ButtonText>
                      <ShareAltOutlined />
                      แชร์ไปยัง Line
                    </ButtonText>
                  </Button>
                </ButtonSection>
              </>
            ) : (
              <NoData />
            )}
          </ContentContainer>
        </div>
      </Loading>
    </>
  );
};

const CustomDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    font-family: "Sarabun", sans-serif;
  }

  .ant-picker-calendar-full .ant-picker-calendar-date {
    font-family: "Sarabun", sans-serif;
  }
`;

const Container = styled.div`
  background: linear-gradient(
    89deg,
    rgb(21, 74, 189) 0.1%,
    rgb(26, 138, 211) 51.5%,
    rgb(72, 177, 234) 100.2%
  );
  height: 300px;
  display: flex;
  gap: 8px;
  padding: 20px;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ContentContainer = styled.div`
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;

  @media (max-width: ${TabletSize}px) {
    padding: 20px;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  @media (max-width: ${TabletSize}px) {
    justify-content: center;
  }
`;

const ButtonText = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.div`
  font-size: ${(props) => props.fontSize};
`;

export default DailyBreadContainer;
